module.exports = __webpack_public_path__ + "static/media/CircularStdMedium.bb9a359a.woff";